<template>
  <div class="ContactPage">
    <div class="container">
      <div class="card shadow-lg p-4">
        <h2 class="text-center mb-4">Contactez-nous</h2>

        <div class="row">
          <div class="col-md-6">
            <div class="map-container" style="height: 350px; border-radius: 8px; overflow: hidden;">
              <h3>Zone de stockage</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2529.5621602301853!2d4.773897377713334!3d50.65382217163172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c1799a7278fb75%3A0xd559748102732685!2sEco-bois!5e0!3m2!1sfr!2sbe!4v1753802782793!5m2!1sfr!2sbe"
                width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <br>
            <div class="map-container" style="height: 350px; border-radius: 8px; overflow: hidden;">
              <h3>Zone d'exploitation</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d4254.069059363472!2d4.789623095408516!3d50.65526249117814!3m2!1i1024!2i768!4f13.1!4m6!3e0!4m0!4m3!3m2!1d50.655274299999995!2d4.7945592!5e0!3m2!1sfr!2sbe!4v1754307947810!5m2!1sfr!2sbe"
                width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>

          <div class="col-md-6 d-flex flex-column justify-content-center">
            <ul class="list-unstyled fs-5 mb-0">
              <li><strong>Adresse :</strong> Chemin des Dix Bonniers, 4 - 1360 Perwez</li>
              <li><strong>GSM :</strong> <a href="tel:+32474625171" class="text-decoration-none">+32 (0)474 62 51 71</a>
              </li>
              <li><strong>Email :</strong> <a href="mailto:info@wicco.be" class="text-decoration-none">info@wicco.be</a>
              </li>
              <li><strong>BCE :</strong> 812106071</li>
              <li><strong>TVA :</strong> BE0812.106.071</li>
              <li><strong>Facebook :</strong>
                <a href="https://www.facebook.com/EcoBois.WiccoServices" target="_blank" rel="noopener noreferrer">
                  EcoBois Wicco Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ContactPage',
  components: {
  }
}
</script>


<style>
.ContactPage a {
  color: #0d6efd;
}
</style>